(function($) {  
  
  
  $('.bullet-section-wrap').each(function(){
      $(this).find('img').hide();
      var _Bg = 'url('+ $(this).find('img').attr('src') + ')';
      $(this).css("background-image", _Bg);
      $(this).find('img').hide();
    }); 
  
   $('.p-img > a').each(function(){
			$(this).find('img').hide();
			var _Bg = 'url('+ $(this).find('img').attr('src') + ')';
			$(this).css("background-image", _Bg);
			$(this).find('img').hide();
		});
  
//   $('.bullet').click(function(){
//     $(this).parent().toggleClass('bullet--active');
//   })
  
   $(document).ready(function(){
  $('.bullet-section-wrap .everything-you-need__StyledBullet-sc-12tayus-1>.bullet').click(function(){
    $('.bullet-section-wrap .everything-you-need__StyledBullet-sc-12tayus-1>.bullet').parent().removeClass("bullet--active");
    $(this).parent().addClass('bullet--active');
});
});
$('.bullet__close').click(function(){
    $(this).parents().removeClass('bullet--active');
  })

$('.menu-link-shop').click(function(){
  $(this).toggleClass('active');
  $('.shop-menu-wrap').toggleClass('active')
})
 
$( "body" ).on( "click", ".menu-link-cart", function( event ) {
  $(this).toggleClass('active');
  $('body').toggleClass('hid');
  $('.side-cart').toggleClass('active');
  $('.overla').toggleClass('cv-cart-open-overlay');
})

$('.window__closer').click(function(){
  $('.menu-link-shop').removeClass('active');
  $('.shop-menu-wrap').removeClass('active')
  $('.side-cart').removeClass('active');
   $('body').removeClass('hid');
  $('.menu-link-cart').removeClass('active');
    $('.overla').removeClass('cv-cart-open-overlay');
})


$('.header__nav-button').click(function(){
  $(this).toggleClass('active')
  $('.mobile-menu').toggleClass('active')
})

$('.shop-list h4').click(function(){
  $(this).toggleClass('show')
  $(this).next('ul').toggleClass('show');
})

$('.r-more').click(function(){
  $(this).hide();
 $('.r-content').addClass('show')
})

$('.r-less').click(function(){
  $('.r-more').show();
 $('.r-content').removeClass('show')
})


$('.product-slider').slick({
  infinite: true,
  dots: true,
  arrows:true,
  slidesToShow: 1,
  prevArrow: $('.prev'),
    nextArrow: $('.next'),
  slidesToScroll: 1
});
  
  $('.everything-carousel').slick({
  infinite: true,
  dots: true,
  arrows:false,
  slidesToShow: 1,
 
slidesToScroll: 1
});

  
  
 
$('.news-carousel').slick({
  dots: true,
  infinite: false,
  speed: 300,
   arrows:false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
});
  
  $('.reviews_carousel').slick({
  dots: true,
  infinite: true,
  speed: 300,
   arrows:false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
});
  
  $('.related-products-carousel').slick({
  dots: true,
  infinite: true,
  speed: 300,
   arrows:false,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: true,
        slidesToScroll: 1
      }
    }
  
  ]
});
  
  
  $('.collection-slider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows:false
});
	

  
  
var btn = $('.back-to-top');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

  
     function checkOffset() {
    if($('.back-to-top').offset().top + $('.back-to-top').height()
                                           >= $('#footer_bottom_row').offset().top - 10)
       $('.back-to-top').addClass('btt');
    if($(document).scrollTop() + window.innerHeight < $('#footer_bottom_row').offset().top)
        $('.back-to-top').removeClass('btt'); // restore when you scroll up
      // $('#ch').text($(document).scrollTop() + window.innerHeight);
}
$(document).scroll(function() {
    checkOffset();
});

$('ul.accordion').accordion();


    var mode  = $(window).innerWidth() >= 1024 ? "PC" : "MOBILE";

  if(mode=="PC"){


  }
  else if(mode=="MOBILE") {


    $(".m-menu").attr("href", "javascript:;");
  }
  
  
  
  
  $(document).ready(function(){
//   $('.down').on('click', function(e) {
				
// 				e.preventDefault(); // prevent hard jump, the default behavior
// 				var target = $(this).attr("href"); // Set the target as variable
// 				console.log(target);
		
// 				$('html, body').stop().animate({
// 						scrollTop: $(target).offset().top - 80
// 				}, 600, function() {
// 						//location.hash = target; //attach the hash (#jumptarget) to the pageurl
// 						console.log($(target).offset().top);
// 				});

// 				return false;				
// 		});
  });
  
  
  
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 120
        }, 600, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
 jQuery('.side-cart-inner').mCustomScrollbar({
        scrollButtons:{enable:true}, theme:"dark", scrollbarPosition:"outside", updateOnContentResize: true,
    });
  
      $('.overla').click(function(){
           
 $('.side-cart').removeClass('active');
  $(".overla").removeClass("cv-cart-open-overlay");
});
})(jQuery);

$( function(){
  $('.innerLanguages').on('click', function(){
    $('.innerLanguages').toggleClass('devActive');
    $('.devLanguagesDropdown').toggle();
  });
});
       




    $(".diblmn").click(function(event) {
      event.preventDefault();
      $('.search-results').show();
      $('.search-results li').focus();
    });

 $('.foo').each(function(){
      var _bg = $(this).find('img').attr('src');
      $(this).css('background-image', 'url(' + _bg + ')' );
    })

    $(document).ready(function() {
      if (window.location.href.indexOf("viewcart") > -1) {
        $(".side-cart").addClass("active");

      }
    });


  $(document).ready(function() {
     



      if (window.location.href.indexOf("limited-fb-promo") > -1) {
        // Store
        localStorage.setItem("limited-fb-promo", "YES");
        // Retrieve
        console.log(localStorage.getItem("limited-fb-promo"));

      }
      console.log(localStorage.getItem("limited-fb-promo"));
      if(localStorage.getItem("limited-fb-promo") == 'YES')
      {

        $(".admvl").attr('name', 'id[]');
      }


    });







